import { ref } from "vue";
import { defineStore } from 'pinia'

export const useScreenStore = defineStore('screen', () => {
  const browserWidth = ref(window.innerWidth);
  const deviceWidth = ref(screen.width);
  const isMobile = ref(false);
  const showSidebar = ref(true);

  const browserResized = () => {
    browserWidth.value = window.innerWidth
    deviceWidth.value = screen.width
    const prev = isMobile.value
    isMobile.value = window.innerWidth <= 880 ? true : false
    if (isMobile.value !== prev) {
      showSidebar.value = true
    }
  }


  return {
    browserWidth,
    deviceWidth,
    isMobile,
    browserResized,
    showSidebar
  }
})
